// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"438":"128376dc","538":"e97cc3a9"}[chunkId] + ".chunk.js";
};